<script>
import ContentBox from '@/components/ui/ContentBox';
import LanguageDropdown from '@/components/i18n/LanguageDropdown';

export default {
  name: 'MinimalLayout',
  components: {
    ContentBox,
    LanguageDropdown
  },
  props: {
    size: {
      default: 'small',
      type: String
    }
  }
};
</script>

<template>
  <div
    :class="{
      'minimal-layout': true,
      'minimal-layout-small': size === 'small',
      'minimal-layout-medium': size === 'medium',
      'minimal-layout-large': size === 'large'
    }"
  >
    <div class="minimal-body">
      <div class="minimal-logo">
        <img :src="$store.state.metadata.logoLight" :alt="$store.state.metadata.appName" />
      </div>
      <content-box>
        <slot />
      </content-box>
    </div>

    <div class="minimal-language">
      <language-dropdown />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.minimal-layout {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: $--color-gray-10;
  border-radius: 0;
  padding: 2rem;

  @include breakpoint('sm-and-down') {
    height: auto;
    padding: 6rem 1rem 2rem 1rem;
  }

  .minimal-logo {
    max-width: 22rem;
    margin: 0 auto 2rem auto;

    img {
      display: block;
      max-width: 90%;
      max-height: 6rem;
      margin: 0 auto;
    }
  }

  .minimal-body {
    width: 100%;

    .content-box {
      padding-top: 2.25rem;
    }
  }

  &.minimal-layout-small .minimal-body {
    max-width: 22rem;
  }

  &.minimal-layout-medium .minimal-body {
    max-width: 30rem;
  }

  &.minimal-layout-large .minimal-body {
    max-width: 38rem;
  }

  .minimal-language {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  /deep/ .el-button--block {
    font-size: 1.1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
</style>
